<!--Header-->
<div class="TextCenter">
	<h4>Facility Assign Locations:</h4>
</div>

<!--Schools that are currently applied to the user-->
<div class="da-Table TopMargin">
	<p-table
		#mydt
		[value]="lstLocations"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedLocations"
		dataKey="FacilityLocationID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--SchoolID-->
				<th>
					<p-columnFilter type="text" field="FacilityLocationCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--School Name-->
				<th>
					<p-columnFilter type="text" field="FacilityLocationName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="FacilityLocationCD">Code<p-sortIcon field="FacilityLocationCD"></p-sortIcon></th>
				<th pSortableColumn="FacilityLocationName">Location Name<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-location>
			<tr [pSelectableRow]="location">
				<td>
					<p-tableCheckbox [pSelectableRow]="location" [value]="location"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ location[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div *ngIf="EditMode == true" class="TextCenter TopMargin">
	<label class="WarnText">NOTE: you have to go to the last page to save your changes and update the facility</label>
</div>

<!--Next-->
<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onEdit()">Edit</button>
	<button class="btn btn-primary" (click)="onRemove()">Remove</button>
	<button class="btn btn-primary" (click)="onToggle()">Toggle Active</button>
	<button class="btn btn-primary" (click)="onNext()">Next</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
